import React from 'react'
import {
  ResponsibleGamingContainer,
  ResponsibleGamingLogos,
  ResponsibleGamingLogo,
  ResponsibleGamingText,
  ResponsibleGamingLogoText,
} from './styles'
import { Image } from '../../atoms/image'

const ResponsibleGaming = ({ responsibleGaming, addOver18Icon }) => {
  const responsibleGamingLogos = addOver18Icon
    ? [
        { logo_image: responsibleGaming?.over_18_icon },
        // eslint-disable-next-line no-unsafe-optional-chaining
        ...responsibleGaming?.resp_gaming_logos,
      ]
    : responsibleGaming?.resp_gaming_logos
  return (
    <ResponsibleGamingContainer>
      <ResponsibleGamingLogos>
        {responsibleGamingLogos?.map((logo, i) => {
          return (
            <ResponsibleGamingLogo key={`rg-logo-${i}`}>
              <Image
                width={'35px'}
                height={'35px'}
                url={logo?.logo_image?.url}
              />
              <ResponsibleGamingLogoText>
                {logo?.logo_text}
              </ResponsibleGamingLogoText>
            </ResponsibleGamingLogo>
          )
        })}
      </ResponsibleGamingLogos>
      <ResponsibleGamingText>
        {responsibleGaming?.resp_gaming_text}
      </ResponsibleGamingText>
    </ResponsibleGamingContainer>
  )
}

export { ResponsibleGaming }
